*,
::after,
::before {
  box-sizing: border-box;
}

:host {
  --ch-textblock-displayed-lines: 1;
  --ch-textblock-line-height: 1px;
  display: inline-grid;
  grid-auto-rows: max-content;
  position: relative;
  text-align: start;
  white-space: break-spaces;
}

:host(.ch-textblock--no-auto-grow) {
  contain: size;
}

.line-measure {
  position: absolute;
  pointer-events: none;
  visibility: hidden;
}

.content,
.html-content {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: var(--ch-textblock-displayed-lines);
  overflow: hidden;
  max-block-size: calc(var(--ch-textblock-displayed-lines) * var(--ch-textblock-line-height));
}

.html-content {
  max-block-size: var(--ch-textblock-available-size);
}